import { Button } from '@simplywallst/ui-core/next';

import PlusSolid from '@simplywallst/ui-core/icons/PlusSolid';
import type { ComponentProps } from 'react';
import { useCreateNarrative } from '@/pages/Narrative/hooks/useCreateNarrative';
type Props = {
  companyId: string;
  uniqueSymbol: string;
  variant?: ComponentProps<typeof Button>['variant'];
  size?: ComponentProps<typeof Button>['size'];
};

export const CompanyNarrativesCreateButton = ({
  companyId,
  uniqueSymbol,
  variant = 'secondary',
  size = 'medium',
}: Props) => {
  const { handleCreateNarrative } = useCreateNarrative({
    companyId,
    uniqueSymbol,
  });

  return (
    <Button variant={variant} size={size} onClick={handleCreateNarrative}>
      <PlusSolid /> Create Narrative
    </Button>
  );
};
